import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgAddRoute(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M18 0a2 2 0 11-.536 3.927l-2.758 2.775a3 3 0 01-3.986 4.011l-2.774 2.825a2 2 0 11-1.375-1.455l2.727-2.777A3 3 0 0113.29 5.29l2.773-2.79A2.004 2.004 0 0118 0zm-6 7a1 1 0 100 2 1 1 0 000-2zM7 0v2h2v2H7v2H5V3.999L3 4V2l2-.001V0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('AddRoute')(SvgAddRoute);
